import { useState, useEffect, createRef } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { setAlert } from '../../actions/alert';
import { editarAhorro, detallesAhorro } from '../../actions/asesorias';

const TIPOS_AHORRO = [
    { value: 1, label: 'Comisiones bancarias' },
    { value: 2, label: 'Tasa de interés' },
    { value: 3, label: 'Seguros' },
    { value: 4, label: 'Crédito' },
    { value: 5, label: 'Otro' }
];

const EditarAhorro = ({ ahorro, reestablecerAhorro }) => {

    const dispatch = useDispatch();

    const { detalles_ahorro } = useSelector(state => state.asesorias);

    const [ahorroData, setAhorroData] = useState({
        id_ahorro: null,
        id_asesoria: null,
        tipo: null,
        banco: null,
        monto_anual: null,
        descripcion: null,
        comprobante: null,
        extension: null,
        url: null
    });

    const [ahorroModal, setAhorroModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    let comprobante_ref = createRef();

    const handleInputChange = ({ target }) => {
        setAhorroData({
            ...ahorroData,
            [target.name]: target.value
        });
    }

    const handleComprobanteElegir = () => {
        return comprobante_ref.current?.click();
    }

    const handleChangeFile = () => {
        const file = comprobante_ref.current.files[0];
        if (!file) return;

        const nombre_separado = file.name.split('.');
        const ext = nombre_separado[nombre_separado.length - 1].toLowerCase();

        if (!['pdf', 'jpg', 'jpeg', 'png'].includes(ext)) {
            dispatch(setAlert('Solo se aceptan archivos PDF, JPG o PNG.', 'danger'));
            comprobante_ref.current.value = '';
            return;
        }

        setAhorroData({
            ...ahorroData,
            comprobante: file,
            extension: ext,
            url: URL.createObjectURL(file)
        });
    }

    const handleVerComprobante = (url) => {
        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        } else {
            dispatch(setAlert('Comprobante no seleccionado', 'danger'));
        }
    }

    const handleProcesar = async () => {
        if (!ahorroData.tipo) {
            dispatch(setAlert('El tipo de ahorro es requerido', 'danger'));
            return;
        }
        if (!ahorroData.banco) {
            dispatch(setAlert('El banco es requerido', 'danger'));
            return;
        }
        if (!ahorroData.monto_anual) {
            dispatch(setAlert('El monto anual es requerido', 'danger'));
            return;
        }
        if (!ahorroData.descripcion) {
            dispatch(setAlert('La descripción es requerida', 'danger'));
            return;
        }

        await setStatusProcesar(true);

        let formData = new FormData();
        formData.append('id_ahorro', ahorroData.id_ahorro);
        formData.append('id_asesoria', ahorroData.id_asesoria);
        formData.append('tipo', ahorroData.tipo);
        formData.append('banco', ahorroData.banco);
        formData.append('monto_anual', ahorroData.monto_anual);
        formData.append('descripcion', ahorroData.descripcion);
        if (ahorroData.comprobante) {
            formData.append('comprobante', ahorroData.comprobante);
            formData.append('extension', ahorroData.extension);
        }

        await dispatch(editarAhorro(formData));
        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if (!statusProcesar) {
            setAhorroData({
                id_ahorro: null,
                id_asesoria: null,
                tipo: null,
                banco: null,
                monto_anual: null,
                descripcion: null,
                comprobante: null,
                extension: null,
                url: null
            });
            reestablecerAhorro(null);
            setAhorroModal(false);
        }
    }

    useEffect(() => {
        if (ahorro) {
            dispatch(detallesAhorro({
                id_asesoria: ahorro.id_asesoria,
                id_ahorro: ahorro.id_ahorro
            }));

            setAhorroData({
                ...ahorroData,
                id_ahorro: ahorro.id_ahorro,
                id_asesoria: ahorro.id_asesoria,
                tipo: ahorro.tipo,
                banco: ahorro.banco,
                monto_anual: ahorro.monto_anual,
                descripcion: ahorro.descripcion,
                extension: ahorro.extension || null,
                url: null
            });

            setAhorroModal(true);
        }
    }, [ahorro]);

    useEffect(() => {
        if (detalles_ahorro && detalles_ahorro?.url_comprobante) {
            setAhorroData(prev => ({
                ...prev,
                url: detalles_ahorro.url_comprobante
            }));
        }
    }, [detalles_ahorro]);

    return (
        <Modal show={ahorroModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Editar ahorro</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="col-md-12 form-group mb-3">
                    <div className="input-group">
                        <div className="form-floating">
                            <select className="form-select" id="tipo" name="tipo" value={ahorroData.tipo || ''} onChange={e => handleInputChange(e)}>
                                <option value="">Seleccionar tipo</option>
                                {TIPOS_AHORRO.map(t => (
                                    <option key={t.value} value={t.value}>{t.label}</option>
                                ))}
                            </select>
                            <label htmlFor="tipo">Tipo de ahorro</label>
                        </div>
                    </div>
                </div>

                <div className="col-md-12 form-group mb-3">
                    <div className="input-group">
                        <div className="form-floating">
                            <input className="form-control" type="text" placeholder="Banco" id="banco" name="banco" value={ahorroData.banco || ''} onChange={e => handleInputChange(e)} />
                            <label htmlFor="banco">Banco</label>
                        </div>
                    </div>
                </div>

                <div className="col-md-12 form-group mb-3">
                    <div className="input-group">
                        <div className="form-floating">
                            <input className="form-control" type="number" min="0" placeholder="Monto anual" id="monto_anual" name="monto_anual" value={ahorroData.monto_anual || ''} onChange={e => handleInputChange(e)} />
                            <label htmlFor="monto_anual">Monto anual ($)</label>
                        </div>
                    </div>
                </div>

                <div className="col-md-12 form-group mb-3">
                    <div className="input-group">
                        <div className="form-floating">
                            <textarea className="form-control textareCampo" placeholder="Descripción" id="descripcion" name="descripcion" value={ahorroData.descripcion || ''} onChange={e => handleInputChange(e)}></textarea>
                            <label htmlFor="descripcion">Descripción</label>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="btn-group w-100" role="group">
                        <button type="button" className="btn btn-outline-secondary" onClick={() => handleComprobanteElegir()}>
                            {ahorroData.url ? (ahorroData.comprobante ? 'Cambiar comprobante' : 'Comprobante existente') : 'Adjuntar comprobante (opcional)'}
                        </button>
                        {
                            ahorroData.url &&
                                <button type="button" className="btn btn-secondary" onClick={() => handleVerComprobante(ahorroData.url)}><i className="fa-solid fa-eye"></i> Ver comprobante</button>
                        }
                    </div>
                    <input type="file" className="d-none" id="comprobante" name="comprobante" accept=".pdf,.jpg,.jpeg,.png" ref={comprobante_ref} onChange={handleChangeFile} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={statusProcesar}><i className="fas fa-times fa-sm"></i> Cancelar</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Guardar</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Guardar</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EditarAhorro;
